<template>
  <div class="wrapper">
    <div class="header-box">
      <navbar></navbar>
    </div>
    <div class="wrapper-bottom">
      <sidebar></sidebar>
      <div class="router-box">
        <div class="router-view">
          <router-view></router-view>
        </div>
      </div>
      <!-- <div class="foot_content">
        <p>电话：0757-85756161     &nbsp;&nbsp;邮箱：naidean@163.com     地址：广东省佛山市南海区大沥镇盐步联安周边村周日电商园3F</p>
        <p> <a href="http://www.naidean.com" target="_blank">www.naidean.com 佛山市耐得安智能科技有限公司版权所有.</a> &nbsp;&nbsp;&nbsp;&nbsp;备案号：粤ICP19068381号</p>
      </div> -->
    </div>
    
  </div>
</template>

<script>
import navbar from "./navbar";
import sidebar from "./sidebar";
export default {
  components: {
    navbar,
    sidebar
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style scoped>
/** 底部备案信息 */
.foot_content{
  position:absolute;
  bottom: 0px;
  height: 60px;
  width: 100%;
  text-align: center;
}

.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.header-box {
  flex-basis: 94px;
}
.wrapper-bottom {
  flex: 1;
  height: 100%;
  width: 100%;
  display: flex;
}
.router-box {
  height: 100%;
  width: 100%;
  /* padding: 20px; */
  background: #f8fafb;
}
.router-view {
  height: 100%;
  width: 100%;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/homepage.vue